import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Header() {
  const navigate = useNavigate();
  const [adminName, setAdminName] = useState("");
  const [mockName,  setMockName]  = useState("");

  useEffect(() => {
    setAdminName(localStorage.getItem("proctorly_admin_email") || "");
    setMockName(localStorage.getItem("mock_name") || "");
  }, []);

  function handleLogout() {
    ["proctorly_admin_token","proctorly_admin_email",
     "mock_token","mock_email","mock_name"].forEach((k) => localStorage.removeItem(k));
    navigate("/");
  }

  const hasAdminSession = !!localStorage.getItem("proctorly_admin_token");
  const hasMockSession  = !!localStorage.getItem("mock_token");
  const hasSession      = hasAdminSession || hasMockSession;
  // Show email for admin, name for mock candidate
  const displayName = adminName || mockName;

  return (
    <header
      className="relative z-30 flex items-center justify-between px-6 md:px-12 py-4 border-b border-white/10"
      data-testid="site-header"
      style={{ background: "rgba(6,10,31,0.75)", backdropFilter: "blur(10px)" }}
    >
      <Link to="/" className="flex items-center text-white" data-testid="brand-link">
        <div className="leading-tight">
          <div className="font-display text-2xl md:text-3xl tracking-tight">
            PROCTORLY <span className="text-[color:var(--kl-red)]">AI</span>
          </div>
          <div className="font-mono-kl text-[9px] tracking-[0.25em] uppercase text-white/55 mt-0.5">
            Powered by Kiba Labs
          </div>
        </div>
      </Link>

      <div className="flex items-center gap-4">
        <Link
          to="/leaderboard"
          className="font-mono-kl text-[10px] uppercase tracking-[0.25em] text-[color:var(--kl-yellow)] hover:text-white transition flex items-center gap-1.5"
          data-testid="header-leaderboard"
        >
          🏆 Leaderboard
        </Link>
        <span className="text-white/15">|</span>
        <Link
          to="/live"
          className="font-mono-kl text-[10px] uppercase tracking-[0.25em] text-[color:var(--kl-red)] hover:text-white transition flex items-center gap-1.5"
          data-testid="header-live"
        >
          <span className="animate-pulse">●</span> Live Arena
        </Link>
        <span className="text-white/15">|</span>
        <Link to="/admin" className="font-mono-kl text-[10px] uppercase tracking-[0.25em] text-white/40 hover:text-white transition" data-testid="header-admin">
          Admin
        </Link>

        {hasSession && (
          <>
            <span className="text-white/15">|</span>
            {displayName && (
              <span className="font-mono-kl text-[10px] uppercase tracking-[0.15em] text-white/50">
                {displayName}
              </span>
            )}
            <button
              onClick={handleLogout}
              className="font-mono-kl text-[10px] uppercase tracking-[0.2em] text-white/40 hover:text-red-400 transition"
              data-testid="header-logout"
            >
              Logout
            </button>
          </>
        )}
      </div>
    </header>
  );
}
